<template>
    <div>
        <div class="content-caption dashed">
            <span>基本信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">标题</label>
                </div>
                <div class="form-value">
                    <el-input class="width-2x" v-model="orderGoodsAllocForm.title"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">要求到货日期</label>
                </div>
                <div class="form-value">
                    <el-date-picker class="width-2x" v-model="orderGoodsAllocForm.desireArriveDate" type="date" placeholder="选择日期" :picker-options="pickerOptions0"></el-date-picker>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>配货机构</span>
        </div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="showShopDlg()">选择机构</button>
            </div>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">业务单元</th>
                <th style="text-align: left">所属部门</th>
                <th style="text-align: left">地址</th>
                <th style="text-align: left">邮箱</th>
                <th style="text-align: left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr v-if="retailerCom != null" class="row">
                <td style="text-align: left">{{retailerCom.bizUnitName}}</td>
                <td style="text-align: left">{{retailerCom.name}}</td>
                <td style="text-align: left">{{retailerCom.regionName || ''}}{{retailerCom.street || ''}}</td>
                <td style="text-align: left">{{retailerCom.contactEmail}}</td>
                <td style="text-align: left">
                    <span class="swb-btn-link" @click="removeRetailerCom()">移除</span>
                </td>
            </tr>
            <tr class="row" v-else>
                <td colspan="4">暂无机构信息</td>
            </tr>
            </tbody>
        </table>
        <div class="simple-row" v-if="retailerCom != null">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="showShopAddrDlg()">选择地址</button>
            </div>
        </div>
        <table class="custom-tbl" v-if="retailerCom != null">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">地址信息</th>
                <th style="text-align: left">详细地址</th>
                <th style="text-align: left">联系人</th>
                <th style="text-align: left">联系电话</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr v-if="retailerCom != null" class="row">
                <td style="text-align: left">
                    <div class="inline-block mr10" style="width: 500px">{{orderGoodsAllocForm.buyerRecvRegionName}}</div>
                </td>
                <td style="text-align: left">
                    <el-input class="inline-block" placeholder="详细地址" style="width: 500px" v-model="orderGoodsAllocForm.buyerRecvStreet"></el-input>
                </td>
                <td style="text-align: left">
                    <el-input class="inline-block" placeholder="联系人" style="width: 500px" v-model="orderGoodsAllocForm.buyerRecvContractName"></el-input>
                </td>
                <td style="text-align: left">
                    <el-input class="inline-block" placeholder="联系电话" style="width: 500px" v-model="orderGoodsAllocForm.buyerRecvContactTel"></el-input>
                </td>
            </tr>
            <tr class="row" v-else>
                <td colspan="4">暂无地址信息</td>
            </tr>
            </tbody>
        </table>
        <div class="content-caption dashed">
            <span>商品信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">供应商</label>
                </div>
                <div class="form-value">
                    <el-input class="width-2x bottom-line" :disabled="true" v-model="orderGoodsAllocForm.sellerName"></el-input>
                    <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="sellerSelect"></i>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">税率(%)</label>
                </div>
                <div class="form-value">
                    <el-input v-model="orderGoodsAllocForm.taxRate" class="width-2x" @change="taxRateChange(orderGoodsAllocForm.taxRate)"></el-input>
                </div>
            </div>
        </div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="showSkuDlg()">选择商品</button>
            </div>
        </div>
        <el-form :model="orderGoodsAllocForm">
            <div class="table-layout">
                <el-table ref="multipleTable" :data="orderGoodsAllocForm.itemList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="center" label="资产信息" v-if="showAssetInfo">
                        <el-table-column align="left" prop="devcName" label="名称"></el-table-column>
                        <el-table-column align="left" prop="devcModel" label="型号" width="120"></el-table-column>
                        <el-table-column align="left" prop="devcFixedSpec" label="规格" width="120"></el-table-column>
                        <el-table-column align="left" prop="devcCatName" label="分类"></el-table-column>
                        <el-table-column align="left" prop="devcBrandName" label="品牌"></el-table-column>
                    </el-table-column>
                    <el-table-column align="center" label="商品信息">
                        <el-table-column align="left" prop="title" label="名称"></el-table-column>
                        <el-table-column align="left" prop="model" label="型号" width="120"></el-table-column>
                        <el-table-column align="left" prop="fixedSpec" label="规格" width="120"></el-table-column>
                        <el-table-column align="left" prop="catName" label="分类" width="120"></el-table-column>
                        <el-table-column align="left" prop="brandName" label="品牌" width="120"></el-table-column>
                    </el-table-column>

                    <el-table-column align="center" prop="asmblAccFlag" label="组装件" width="130">
                        <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.asmblAccFlag" @change="setAsmblAccFlag(scope.row)">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">否</el-radio>
                            </el-radio-group>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" label="关联定义">
                        <template slot-scope="rows">
                            <div class="inline-block" v-if="rows.row.assetDefId != null">已关联</div>
                            <div class="inline-block" v-else>未关联</div>
                            <a class="swb-btn-link fr inline-block" @click="delDevcDef(rows.row)">清除</a>
                            <a class="swb-btn-link fr inline-block" @click="setDevcDef(rows.row)">选择</a>
                            <a class="swb-btn-link fr inline-block" v-if="rows.row.assetDefId == null && (rows.row.asmblAccFlag || (!needAudit && !rows.row.asmblAccFlag))" @click="saveDevcDef(rows.row)">生成定义</a>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="120px" prop="devcName" label="定义全名称">
                        <template slot-scope="rows">
                            <div class="inline-block" v-if="rows.row.assetDefId != null">{{rows.row.devcName || ''}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="price" label="含税价(元)" width="90">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="scope.row.price" @change="changePrice(scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="taxRate" label="税率(%)" width="90">
                        <template slot-scope="scope">
                            <span> {{scope.row.taxRate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="ntxPrice" label="未税价(元)" width="90">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ntxPrice != null">{{scope.row.ntxPrice}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="right" label="下单数量" width="90">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="scope.row.quantity"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="unit" label="单位" width="80"></el-table-column>
                    <el-table-column align="left" label="说明" width="150">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="scope.row.desc"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="操作" width="100">
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="removeGoods(scope.row.skuId)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary" @click="goBack">取消</button>
            <button class="swb-btn swb-btn-small" @click="submitClick">提交</button>
        </div>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf';
    import goodsOrderApi from '../../api/goodsOrder'
    import userApi from '../../api/user'
    import retailerApi from '../../api/retailer'
    import devcDefApi from '../../api/devcDef'
    import asmblAccApi from '../../api/asmblAcc'
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'
    import{ openSkuListSelectDlg } from '../goods/selectDlg'
    import { showMerchtDevcDefSelectDlg, openDevcDefSaveDlg } from '../devcDef/showDlg'
    import { showAsmblAccDefSelectDlg, openAccDefSaveDlg } from '../asmblAcc/dialog'
    import { getMerchantBizParam } from '../asset/assetMain'
    //
    import SwbRetailerAddrSelect from '../retailer/RetailerAddrSelect'
    Vue.regist(SwbRetailerAddrSelect);
    import SwbOrderGoodsAllocFormList from '../order/OrderGoodsAllocFormList'
    Routes.add(SwbOrderGoodsAllocFormList);
    //
    export default {
        name: 'swb-order-goods-alloc-form-save',
        path: '/order/goods/alloc/form/save',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        customBreadcrumb: false,
        parentBreadcrumbUrl: '/order/goods/alloc/form/list',
        desc: '配货单新增',
        data: function () {
            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                orderGoodsAllocForm: {
                    itemList: [],
                    desireArriveDate: null
                },
                retailerCom: null,
                buyerId: null,
                formId: null,
                shopFlag: false,
                normalFlag: false,
                showAssetInfo: false,
                needAudit: false
            }
        },
        created: function () {
            let self = this;
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            getMerchantBizParam("asset.definition.create.alter.need.audit", function (result) {  // 新增/变更资产定义是否需要审核
                self.needAudit = Utils.isTrue(result);
            }, 0);
            this.formId = this.$route.query.formId || null;
            if(!Utils.isNoB(this.formId)) {
                this.getOrderGoodsAllocFormById(this.formId);
            } else {
                this.getUserInfo();
            }
        },
        methods: {
            taxRateChange: function (taxRate) {
                if(!Utils.isNoB(taxRate)) {
                    if(!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if(taxRateF > 100) {
                            taxRate = null;
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                } else {
                    taxRate = null;
                }
                let orderGoodsAllocForm = this.orderGoodsAllocForm || {};
                orderGoodsAllocForm.taxRate = taxRate;
                let itemList = orderGoodsAllocForm.itemList || [];
                if(itemList.length > 0) {
                    for(let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        //
                        item.taxRate = taxRate;
                        if(Utils.isNoB(taxRate) || Utils.isNoB(item.price)) {
                            item.ntxPrice = item.price;
                        } else {
                            item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                        }
                    }
                }
                orderGoodsAllocForm.itemList = Utils.merge([], itemList);
                this.orderGoodsAllocForm = Utils.merge({}, orderGoodsAllocForm);

                if(Utils.isNoB(taxRate)) {
                    MsgBox.warning("请输入税率！");
                    return;
                }
            },
            changePrice: function (row) {
                let orderGoodsAllocForm = this.orderGoodsAllocForm || {};
                let taxRate = orderGoodsAllocForm.taxRate;
                if(!Utils.isMoneyStr(row.price, true)) {
                    Toast.show("请输入有效的价格");
                    return false;
                }
                if(!Utils.isNoB(taxRate)) {
                    row.ntxPrice = ( row.price / (1 + (taxRate * 0.01))).toFixed(2);
                } else {
                    row.ntxPrice = row.price;
                }
            },
            //
            getUserInfo(){
                let self = this;
                let theLoad = MsgBox.loading();
                userApi.getUserInfoByContext({}, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        self.buyerId = data.merchantId;
                        let shopFlag = data.scopeEntity.shopFlag;
                        self.shopFlag = shopFlag;
                        if(Utils.isTrue(shopFlag)) {
                            self.getRetailerCom();
                        }
                    }
                });
            },
            getOrderGoodsAllocFormById: function (formId) {
                let self = this;
                let postData = {
                    fromId: formId,
                };
                let loading = MsgBox.loading();
                goodsOrderApi.getOrderGoodsAllocFormById(postData, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let data = result.data;
                        let orderGoodsAllocForm = data;
                        let itemList = orderGoodsAllocForm.itemList || [];
                        for(let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            item.devcName = item.title || '' + item.model || '' + item.fixedSpec || '';
                        }
                        orderGoodsAllocForm.itemList = Utils.merge([], itemList);
                        orderGoodsAllocForm.desireArriveDate = itemList[0].desireArriveDate;
                        orderGoodsAllocForm.taxRate = itemList[0].taxRate;
                        self.orderGoodsAllocForm = orderGoodsAllocForm;

                        self.getRetailerCom(data.buyerShopId)
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getRetailerCom: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                retailerApi.getRetailerCom(postData, function (result) {
                    if(result.type == "info") {
                        let data = result.data;
                        let comId = data.id;
                        self.retailerCom = data;
                        self.buyerShopId = comId;
                        if(Utils.isNoB(self.formId)) {
                            if(self.shopFlag) {
                                let orderGoodsAllocForm = self.orderGoodsAllocForm;
                                orderGoodsAllocForm.buyerShopId = comId;
                                self.orderGoodsAllocForm = Utils.merge({}, orderGoodsAllocForm);
                            }
                            self.getRetailerAddrListByComId(comId);
                        }
                    }
                })
            },
            showShopDlg: function () {
                let self = this;
                Vue.$showDialog({
                    title: '零售商机构-选择',
                    width: 750,
                    height: 700,
                    showCloseBtn: true,
                    template: '<swb-org-tree :isShowIcon="false" :isSelectThisLevel="isSelectThisLevel" :isRadio="isRadio" :isCom="isCom" :bizDepart="true"  ref="swb_org_tree"></swb-org-tree>',
                    data: {
                        isRadio: true,
                        isCom: false,
                        isSelectThisLevel: true
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_org_tree.getDlgResult() || {};
                        if(result.type == "info") {
                            //
                            let retailerCom = result.data;
                            self.retailerCom = retailerCom;
                            self.buyerShopId = retailerCom.id;
                            let orderGoodsAllocForm = self.orderGoodsAllocForm;
                            orderGoodsAllocForm.buyerShopId = retailerCom.id;
                            orderGoodsAllocForm.buyerRecvContractName = self.retailerCom.contactName;
                            orderGoodsAllocForm.buyerRecvContactTel = self.retailerCom.contactTel;
                            self.getRetailerAddrListByComId(retailerCom.id);
                            getMerchantBizParam("asset.finac.enabled", function (normalFlagResult) {
                                self.normalFlag = Utils.isTrue(normalFlagResult);
                            }, 2, retailerCom.id);
                        } else {
                            return false;
                        }
                    },
                    lifecycle: {
                        created: function () {
                        }
                    },
                });
            },
            getRetailerAddrListByComId: function (shopId) {
                let self = this;
                let postData = {};
                postData.comId = shopId;
                postData.merchantId = self.buyerId;
                postData.recvFlag = true;
                postData.defRevcFlag = true;
                //
                retailerApi.getRetailerAddrList(postData, function (result) {
                    if(result.type === "info") {
                        let addrList = result.data;
                        let orderGoodsAllocForm = self.orderGoodsAllocForm;
                        let retailerCom = self.retailerCom;
                        if(addrList != null && addrList.length > 0) {
                            let addr = addrList[0];
                            orderGoodsAllocForm.buyerRecvRegionId = addr.regionId;
                            orderGoodsAllocForm.buyerRecvRegionName = addr.regionName;
                            orderGoodsAllocForm.buyerRecvStreet = addr.street;
                        } else {
                            orderGoodsAllocForm.buyerRecvRegionId = retailerCom.regionId;
                            orderGoodsAllocForm.buyerRecvRegionName = retailerCom.regionName;
                            orderGoodsAllocForm.buyerRecvStreet = retailerCom.street;
                        }

                        self.orderGoodsAllocForm = Utils.merge({}, orderGoodsAllocForm);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            removeRetailerCom: function () {
                this.retailerCom = null;
            },
            showShopAddrDlg: function () {
                let self = this;
                let orderGoodsAllocForm = self.orderGoodsAllocForm;
                let buyerShopId = self.buyerShopId;
                Vue.$showDialog({
                    title: '选择机构收货地址',
                    width: 800,
                    height: 500,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-retailer-addr-select :comId="comId" :checkBox = "false"  ref="swb_retailer_addr_list_select"></swb-retailer-addr-select>' +
                    '</div>',
                    data: {
                        comId: buyerShopId
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_retailer_addr_list_select.getDlgResult() || {};
                        if(result.type == 'info') {
                            let shopAddr = result.data;
                            orderGoodsAllocForm.buyerRecvRegionId = shopAddr.regionId;
                            orderGoodsAllocForm.buyerRecvRegionName = shopAddr.regionName;
                            orderGoodsAllocForm.buyerRecvStreet = shopAddr.street;
                            //
                            self.orderGoodsAllocForm = Utils.merge({}, orderGoodsAllocForm);
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {}
                })
            },
            sellerSelect: function () {
                let self = this;
                let params = {
                    showContract: true,
                    showOrder: true,
                    showAmbilateralBizRel: true,
                    showBizRel: true,
                    showAdverseBizRel: true,
                    showNoScoreBizRel: true,
                    showShieldedBizRel: true,
                    showAll: true,
                    multiSelect: false
                };
                let orderGoodsAllocForm = self.orderGoodsAllocForm;
                let taxRate = orderGoodsAllocForm.taxRate;
                openVendorSelectComnDlg(self, params, function (result) {
                    let seller = result.checkedList;
                    orderGoodsAllocForm.sellerId = seller.id;
                    orderGoodsAllocForm.sellerName = seller.name;
                    orderGoodsAllocForm.itemList = [];
                    orderGoodsAllocForm.sellerType = 2;
                    self.orderGoodsAllocForm = Utils.merge({}, orderGoodsAllocForm);
                })
            },
            showSkuDlg: function () {
                let self = this;
                let orderGoodsAllocForm = self.orderGoodsAllocForm;
                if(Utils.isNoB(orderGoodsAllocForm.sellerId)) {
                    MsgBox.warning("请选择供应商信息");
                    return;
                }
                let filter = {
                    merchantId: orderGoodsAllocForm.sellerId,
                    merchantType: orderGoodsAllocForm.sellerType,
                    shelfState: 1,
                };
                let dbItemList = orderGoodsAllocForm.itemList;
                let taxRate = orderGoodsAllocForm.taxRate;
                let skuIds = dbItemList.pluck("skuId") || [];
                filter.saleHalted = false;
                openSkuListSelectDlg(true, filter, skuIds, function (result) {
                    let itemList = result || [];
                    itemList.forEach(function (item) {
                        item.skuId = item.id;
                        item.quantity = null;
                        //
                        item.asmblAccFlag = false;
                        item.vendorUknoFlag = false;
                        item.setupFlag = false;
                        item.asmblFlag = false;
                        item.price = null;
                        item.ntxPrice = null;
                        item.taxRate = null;
                        item.arriveDays = null;
                        item.taxRate = taxRate;
                    });
                    orderGoodsAllocForm.itemList = dbItemList.concat(itemList);
                    self.orderGoodsAllocForm = Utils.merge({}, orderGoodsAllocForm);
                })
            },
            removeGoods: function (skuId) {
                let self = this;
                let orderGoodsAllocForm = self.orderGoodsAllocForm;
                let itemList = orderGoodsAllocForm.itemList;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(item.skuId == skuId) {
                        itemList.splice(i, 1);
                    }
                }
                orderGoodsAllocForm.itemList = itemList;
                self.orderGoodsAllocForm = Utils.merge({}, orderGoodsAllocForm);
            },

            submitClick: function () {
                let self = this;
                let orderGoodsAllocForm = self.orderGoodsAllocForm;
                if(Utils.isNoB(orderGoodsAllocForm.title)) {
                    Toast.show("请输入标题");
                    return false;
                }
                if(!Utils.isNoB(orderGoodsAllocForm.desireArriveDate)) {
                    orderGoodsAllocForm.desireArriveDate = orderGoodsAllocForm.desireArriveDate.format("yyyy-MM-dd");
                } else {
                    Toast.show("请选择到货日期！");
                    return false;
                }
                if(Utils.isNoB(orderGoodsAllocForm.buyerShopId)) {
                    Toast.show("请选择配货机构！");
                    return false;
                }
                if(!Utils.isNoB(orderGoodsAllocForm.buyerRecvContactTel) && !Utils.isPhoneNo(orderGoodsAllocForm.buyerRecvContactTel)) {
                    Toast.show("联系电话错误！");
                    return false;
                }
                if(Utils.isNoB(orderGoodsAllocForm.sellerId)) {
                    Toast.show("请选择供应商信息！");
                    return false;
                }
                if(Utils.isNoB(orderGoodsAllocForm.taxRate)) {
                    Toast.show("税率不可为空！");
                    return false;
                }
                let itemList = orderGoodsAllocForm.itemList;
                if(Utils.isNoB(itemList) || itemList.length <= 0) {
                    Toast.show("请选择商品信息！");
                    return false;
                } else {
                    for(let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        if(Utils.isNoB(item.assetDefId)) {
                            Toast.show("【" + item.title + "】 需选择定义！");
                            return false;
                        }
                        //
                        if(!Utils.isMoneyStr(item.price, true)) {
                            Toast.show("【" + item.title + "】请输入有效的价格");
                            return false;
                        }
                        if(Utils.isNoB(item.taxRate)) {
                            Toast.show("【" + item.title + "】请输入税率");
                            return false;
                        } else {
                            if(!Utils.isMoneyStr(item.taxRate, true)) {
                                Toast.show("【" + item.title + "】请输入有效的税率");
                                return false;
                            }
                        }
                        //
                        if(!Utils.isNaturalStr(item.quantity, true)) {
                            Toast.show("【" + item.title + "】请输入有效的下单数量");
                            return false;
                        }
                    }
                }
                let loading = MsgBox.loading();
                goodsOrderApi.doSaveOrderGoodsAllocForm(orderGoodsAllocForm, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        MsgBox.success("保存成功");
                        self.$router.push({
                            path: SwbOrderGoodsAllocFormList.path,
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            goBack: function () {
                this.$router.push({
                    path: SwbOrderGoodsAllocFormList.path
                });
            },
            setAsmblAccFlag: function (row) {
                let self = this;
                row.assetDefId = null;
                row.devcName = null;
                self.orderGoodsAllocForm.itemList = Utils.merge({}, self.orderGoodsAllocForm.itemList);
            },
            setDevcDef(row) {
                let self = this;
                if(row.asmblAccFlag) {
                    showAsmblAccDefSelectDlg({
                        filter: {},
                        checkBox: false
                    }, function (devcDef, dlg) {
                        dlg.close();
                        row.assetDefId = devcDef.id;
                        row.devcName = devcDef.title;
                        self.orderGoodsAllocForm.itemList = Utils.merge({}, self.orderGoodsAllocForm.itemList);
                    });
                } else {
                    showMerchtDevcDefSelectDlg({
                        catId: row.catId,
                        brandId: row.brandId,
                        modelSpec: row.shortSpec,
                        normalized: Utils.isTrue(self.normalFlag) ? true : null
                    }, function (devcDef, dlg) {
                        dlg.close();
                        row.assetDefId = devcDef.id;
                        row.devcName = devcDef.title;
                        self.orderGoodsAllocForm.itemList = Utils.merge({}, self.orderGoodsAllocForm.itemList);
                    });
                }
            },
            delDevcDef(row) {
                let self = this;
                if(row.assetDefId != null) {
                    row.assetDefId = null;
                    row.devcName = null;
                    self.orderGoodsAllocForm.itemList = Utils.merge({}, itemList);
                }
            },

            saveDevcDef(row){
                let self = this;
                let brandId = row.brandId == null ? -1 : row.brandId;
                let itemList = self.orderGoodsAllocForm.itemList;
                let devcDef = {};
                devcDef.name = row.title;
                devcDef.model = row.model;
                devcDef.fixedSpec = row.fixedSpec;
                devcDef.theUnit = row.unit;
                devcDef.catId = row.catId;
                devcDef.catName = row.catName;
                devcDef.brandId = brandId;
                devcDef.brandName = row.brandName;
                devcDef.createDef = true;

                if(row.asmblAccFlag) {
                    devcDef.centBuyMode = false;
                    openAccDefSaveDlg({
                        row: devcDef,
                        buildFlag: true
                    }, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.assetType = 3;
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        asmblAccApi.getAsmblAccDefByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if(result.type == 'info') {
                                let accDef = result.data;
                                row.assetDefId = accDef.id;
                                row.devcName = accDef.title;
                                self.orderGoodsAllocForm.itemList = Utils.merge({}, itemList);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                } else {
                    devcDef.centBuyRequired = false;
                    devcDef.vendorUknoFlag = false;
                    devcDef.setupFlag = false;
                    devcDef.asmblFlag = false;
                    devcDef.asmblWhileSetup = false;
                    devcDef.stockFifo = false;
                    devcDef.assetType = 0;
                    devcDef.purchFlag = true;
                    let params = {
                        row: devcDef,
                        normalized: Utils.isTrue(self.normalFlag),
                        assetTypeDisabled: true,
                        purchFlagDisabled: true
                    };
                    openDevcDefSaveDlg(params, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.createFlag = true;
                        postData.normalized = Utils.isTrue(self.normalFlag);
                        let msgBoxDlg = MsgBox.loading();
                        devcDefApi.getMerchtDevcDefInfoByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if(result.type == 'info') {
                                let devcDef = result.data;
                                row.assetDefId = devcDef.id;
                                row.devcName = devcDef.title;
                                self.orderGoodsAllocForm.itemList = Utils.merge({}, itemList);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                }
            }
        }
    }
</script>
<style>
    .el-date-editor.el-input {
        width: 320px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocFormSave.vue